export const buttonTypes = {
  PRIMARY_FILL: 'primaryFill',
  PRIMARY_OUTLINE: 'primaryOutline',
  ERROR_FILL: 'errorFill',
  ERROR_OUTLINE: 'errorOutline',
  CUSTOM_FILL: 'CustomFill',
  CUSTOM_OUTLINE: 'CustomOutline',
  NO_STYLE: 'noStyle',
}
